import type { Document } from "@op/richtext-types";

export function isEmpty(doc: Document) {
  // @ts-ignore
  return !(doc.content.length > 1) && !doc.content[0]?.content?.length;
}
